import {
    makeOneToOneCallKitAudioCall,
    makeOneToOneCallKitVideoCall,
    makeGroupCallKitCall,
    attendCallKitCall,
    rejectCallKitCall,
    acceptWaitingCallKitCall,
    declineWaitingCallKitCall,
    endCallKitCall,
    toggleCallKitAudio,
    toggleCallKitVideo,
    inviteUsersToCallKit,
    switchVideoCall,
    subscribeCallEvent,
    unSubscribeCallEvent,
    joinCallEvent,
    getCallLogs,
    deleteCallLogs,
    seenCallLogs,
    scheduleMeet,
    startScreenCapture,
    stopScreenCapture,
} from '../utils/sdkCallMethods';

/**
 * Call Service — single entry point for all call SDK operations.
 * Viewmodels call this service; they never import from utils/sdkCallMethods directly.
 *
 * All state mutations happen inside sdkCallMethods.js (dispatches to callkitDataSlice).
 */

export const makeOneToOneAudioCall = userId => makeOneToOneCallKitAudioCall(userId);
export const makeOneToOneVideoCall = userId => makeOneToOneCallKitVideoCall(userId);
export const makeGroupCall = (userIds, groupId, isVideo, groupName) =>
    makeGroupCallKitCall(userIds, groupId, isVideo, groupName);
export const inviteUsers = userIds => inviteUsersToCallKit(userIds);
export const endCall = () => endCallKitCall();
export const attendCall = () => attendCallKitCall();
export const rejectCall = () => rejectCallKitCall();
export const acceptWaitingCall = () => acceptWaitingCallKitCall();
export const declineWaitingCall = () => declineWaitingCallKitCall();
export const toggleAudio = isMuted => toggleCallKitAudio(isMuted);
export const toggleVideo = isMuted => toggleCallKitVideo(isMuted);
export const switchVideo = (status, cb) => switchVideoCall(status, cb);
export const subscribeCall = (link, cb) => subscribeCallEvent(link, cb);
export const unSubscribeCall = cb => unSubscribeCallEvent(cb);
export const joinCall = (audioMute, videoMute, cb) => joinCallEvent(audioMute, videoMute, cb);
export const getCallLog = (logdata, cb) => getCallLogs(logdata, cb);
export const deleteCallLog = (deleteData, cb) => deleteCallLogs(deleteData, cb);
export const seenCallLog = (seenData, cb) => seenCallLogs(seenData, cb);
export const scheduleMeeting = data => scheduleMeet(data);
export const startScreen = cb => startScreenCapture(cb);
export const stopScreen = cb => stopScreenCapture(cb);
